export class  Graphs {
    roomIds: string[];
    properties: Array<string>;
    dateTimeFrom: string;
    dateTimeTo: string;
  }
